export default [
  {
    path: '/usermanagement',
    name: 'managementUser',
    component: () => import(/*webpackChunkName:'di'*/ '@/views/managementUser/ManagementUser.vue'),
    meta: {},
  },
];
